let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kTZUk")).then(() => parcelRequire('8M3x5'));